import { render } from "./NoAccess.vue?vue&type=template&id=6d59048f&scoped=true&ts=true"
import script from "./NoAccess.vue?vue&type=script&lang=ts"
export * from "./NoAccess.vue?vue&type=script&lang=ts"

import "./NoAccess.vue?vue&type=style&index=0&id=6d59048f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d59048f"]])

export default __exports__